import Big from 'big.js'
import { ComboboxItem } from '@node-space/ui-components'

export interface ApprovalBandDraft {
  from: number | string
  to?: number | string
  approvals: number
}

export const useApproverCount = (startIteratorFrom: number): ComboboxItem[] => {
  const arrayLength = startIteratorFrom === 0 ? 10 : 9
  return [...Array(arrayLength)].map((_, i) => {
    const iteratorValue = startIteratorFrom + i
    return { leftText: `${iteratorValue}`, value: `${iteratorValue}` }
  })
}

export const useApprovalRangeConfig = (approvalBands: ApprovalBandDraft[], rowIndex: number) => {
  const rowCount = approvalBands?.length
  const isLastRow = rowIndex === rowCount - 1

  const currentRowFromValue = approvalBands?.[rowIndex]?.from
  const currentRowToValue = approvalBands?.[rowIndex]?.to
  const previousRowToValue = approvalBands?.[rowIndex - 1]?.to

  const incrementedToValue = previousRowToValue ? Big(previousRowToValue).plus(0.01).toString() : ''

  const isUnbounded = isLastRow && currentRowToValue === undefined

  const addButtonIsVisible = rowCount === 1 || (rowCount > 1 && isLastRow)
  const deletebuttonIsVisible = rowIndex !== 0 && rowCount > 1 && isLastRow

  const currentRowToValueToNumber = Number(currentRowToValue)
  const isCurrentRowRangeInvalid =
    !isUnbounded &&
    (currentRowToValue === undefined ||
      currentRowToValue === '' ||
      Number.isNaN(currentRowToValueToNumber) ||
      currentRowToValueToNumber <= 0 ||
      currentRowToValueToNumber <= Number(currentRowFromValue))
  const isAnyToValueInvalid = !!approvalBands?.some(
    (band, index) =>
      index !== rowCount - 1 && (band?.to === undefined || band?.to === '' || Number(band?.to) <= 0)
  )

  const prefillFromValue = rowIndex > 0 ? incrementedToValue : currentRowFromValue?.toString()
  const toInputIsDisabled = rowCount === 1 || isUnbounded

  return {
    rowCount,
    prefillFromValue,
    toInputIsDisabled,
    isUnbounded,
    addButtonIsVisible,
    deletebuttonIsVisible,
    currentRowToValue,
    isCurrentRowRangeInvalid,
    approvalRangeIsInvalid: isCurrentRowRangeInvalid || isAnyToValueInvalid,
  }
}
